export const getDeeplinkHost = () => {
    const hostname = window.location.hostname;
    let origin = '';
    if (hostname.includes('stg')) {
        origin = 'https://stage.servicetitan.com';
    } else {
        origin = 'https://go.servicetitan.com';
    }
    return origin;
};
